module.exports = __webpack_public_path__ + "static/media/default_img.97cf4ef8.jpg";